<template>
  <div class="search-heroes-by-name">
    <el-form
      class="search-heroes__form card"
      :rules="searchByNameRules"
      :model="searchByNameForm"
      label-position="top"
      ref="searchByNameForm"
      @submit.native.prevent="validate"
    >
      <el-form-item label="Name" prop="name" :error="searchByNameErrors.name">
        <el-input v-model="searchByNameForm.name" />
      </el-form-item>
    </el-form>
    <div class="search-heroes__buttons">
      <el-button
        type="primary"
        @click="validate"
        :disabled="isButtonDisabled('search-participants')"
      >
        Search
      </el-button>
    </div>
  </div>
</template>

<script>
import { parseErrorsByFields } from '@/utils/index.js';
import { searchParticipant } from '@/api/events.js';
import { disableButton } from '@/mixins/disableButton.js';

export default {
  name: 'SearchByName',
  props: {
    skip: {
      type: Number,
      required: false,
    },
    limit: {
      type: Number,
      required: false,
    },
    eventId: {
      type: Number,
      required: false,
    },
  },
  mixins: [disableButton],
  data() {
    return {
      searchByNameForm: { name: null },
      searchByNameRules: {
        name: [
          {
            required: true,
            trigger: 'input',
            message: 'Please enter name',
          },
        ],
      },
      searchByNameErrors: { name: null },
    };
  },
  computed: {
    formData() {
      const { skip, limit, eventId } = this;
      const { name } = this.searchByNameForm;

      return {
        skip,
        limit,
        filterModel: {
          userName: name,
          eventId,
        },
      };
    },
  },
  methods: {
    parseErrorsByFields,
    async fetchParticipants() {
      this.disableButton('search-participants');

      const { formData } = this;
      const { errors, success, data } = await searchParticipant(formData);
      this.enableButton('search-participants');

      if (success) {
        this.$emit('recieve-data', data);
      } else if (errors) {
        this.searchByNameErrors = {
          ...this.searchByNameErrors,
          ...this.parseErrorsByFields(errors),
        };
      }
    },
    validate() {
      const { name } = this.searchByNameForm;

      if (name && name.trim()) {
        this.fetchParticipants();
      }

      if (this.$refs.searchByNameForm) {
        this.$refs.searchByNameForm.validate();
      }
    },
  },
};
</script>

<style lang="scss">
.search-heroes-by-name {
  margin-bottom: var(--global-dimension-size-250);
}
</style>
